module.exports = __webpack_public_path__ + "img/box_angle.48243ded.png";